// import { configureStore } from "@reduxjs/toolkit";
// import modalReducer from "./features/modalSlice";
// import tableReducer from "./features/tableSlice";
// import authReducer from "./features/authSlice";
// import refreshReducer  from"./features/refreshSlice";
// import staffModalReducer from "./features/staffModalSlice";
// import { baseApi } from "./services/baseApi";
// export const store = configureStore({
//   reducer: {
//     auth: authReducer,
//     modal: modalReducer,
//     table: tableReducer,
//         refresh: refreshReducer,
//          staffModal: staffModalReducer,

//     [baseApi.reducerPath]: baseApi.reducer
//   },
//      middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(baseApi.middleware),
// });


import { configureStore, combineReducers } from "@reduxjs/toolkit";

import modalReducer from "./features/modalSlice";
import tableReducer from "./features/tableSlice";
import authReducer from "./features/authSlice";
import refreshReducer from "./features/refreshSlice";
import staffModalReducer from "./features/staffModalSlice";
import productModalReducer from "./features/productModalSlice";

import { baseApi } from "./services/baseApi";

// ================= Redux Persist =================
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// ================= Persist Config =================
const authPersistConfig = {
  key: "auth",
  storage,
};

// ================= Root Reducer =================
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),

  modal: modalReducer,

  table: tableReducer,

  refresh: refreshReducer,
productModal: productModalReducer,
  staffModal: staffModalReducer,

  [baseApi.reducerPath]: baseApi.reducer,
});

// ================= Store =================
export const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
});

// ================= Persistor =================
export const persistor = persistStore(store);